export const PERSONNEL_COLLECTION = 'personnel';

export const TEAM_COLLECTION = 'teams';

export const TEAM_TYPE_COLLECTION = 'team-types';



// WEBPACK FOOTER //
// ./src/js/personnel/domain/config.js